import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { uploadProps, uploadEmits } from './upload';
import { UPDATE_MODEL_VALUE } from '../../constants';
import { UiIconAddOutline, UiIconDeleteOutline } from '../../icons';
import createComponentId from '../../utils/createComponentId';


const __default__ = {
    name: 'UiUpload',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: uploadProps,
  emits: uploadEmits,
  setup(__props, { emit: emits }) {

const props = __props




const inputId = createComponentId('ui-upload');

const files = computed<File[]>(() =>
    Array.isArray(props.modelValue) ? props.modelValue : [],
);

const isButtonVisible = computed<boolean>(() =>
    !props.hideButtonAfterUpload || files.value.length === 0,
);

const handleChange = (event: Event): void => {
    const target = event.target as HTMLInputElement;
    let next = Array.from(target.files ?? []);

    if (props.multiple && props.limit) {
        next = next.slice(0, props.limit);
    }

    emits(UPDATE_MODEL_VALUE, next);
    emits('change', next);
    target.value = '';
};

const handleDelete = (index: number): void => {
    const next = files.value.filter((_, i) => i !== index);
    emits(UPDATE_MODEL_VALUE, next);
    emits('delete', next);
};

return { __sfc: true,props, emits, inputId, files, isButtonVisible, handleChange, handleDelete, UiIconAddOutline, UiIconDeleteOutline }
}

})